import axios from "../network/reuset";
import qs from "qs";

const getAdmin = {
  getList(params) {
    return axios.post(`/api/admin/admin_user/list`, qs.stringify(params));
  },
  getInfo(params) {
    return axios.post(`/api/admin/admin_user/info`, qs.stringify(params));
  },
  postAdd(params) {
    return axios.post(`/api/admin/admin_user/add`, qs.stringify(params));
  },
  postSave(params) {
    return axios.post(`/api/admin/admin_user/save`, qs.stringify(params));
  },
  postDel(params) {
    return axios.post(`/api/admin/admin_user/del`, qs.stringify(params));
  },
  getPermissionTree(params) {
    return axios.post(
      `/api/admin/admin_user/permission_tree`,
      qs.stringify(params)
    );
  },
  getPermissionInfo(params) {
    return axios.post(
      `/api/admin/admin_user/permission_info`,
      qs.stringify(params)
    );
  },
  postPermissionSave(params) {
    return axios.post(`/api/admin/admin_user/permission_save`, params);
  },
  getAppPermissionInfo(params) {
    return axios.post(
      `/api/admin/admin_user/app_permission_info`,
      qs.stringify(params)
    );
  },
  postAppPermissionSave(params) {
    return axios.post(`/api/admin/admin_user/app_permission_save`, params);
  },
};

export default getAdmin;
